import { isString } from 'lodash-es'

import { isValidCurrencyAmount } from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/validationUtils'

const providerRatesValidate = ($$values: any) => {
  const errors: Record<string, string | undefined> = {}

  const areNumbers = [
    {
      fieldName: 'individual_initial_evaluation',
      errorText: 'Individual initial evaluation',
    },
    {
      fieldName: 'individual_follow_up_session',
      errorText: 'Individual follow up',
    },
    {
      fieldName: 'couples_initial_evaluation',
      errorText: 'Couples initial evaluation',
    },
    {
      fieldName: 'couples_follow_up_session',
      errorText: 'Couples follow up',
    },
    {
      fieldName: 'family_initial_evaluation',
      errorText: 'Family initial evaluation',
    },
    {
      fieldName: 'family_follow_up_session',
      errorText: 'Family follow up',
    },
    {
      fieldName: 'group_initial_evaluation',
      errorText: 'Group initial evaluation',
    },
    {
      fieldName: 'group_follow_up_session',
      errorText: 'Group follow up',
    },
    {
      fieldName: 'medication_management_initial_evaluation',
      errorText: 'Medication management initial evaluation',
    },
    {
      fieldName: 'medication_management_follow_up_session',
      errorText: 'Medication management follow up',
    },
    {
      fieldName: 'medication_management_follow_up_low_complexity',
      errorText: 'Medication management follow up (low complexity)',
    },
    {
      fieldName: 'medication_management_follow_up_moderate_complexity',
      errorText: 'Medication management follow up (moderate complexity)',
    },
    {
      fieldName: 'medication_management_follow_up_high_complexity',
      errorText: 'Medication management follow up (high complexity)',
    },
    {
      fieldName: 'child_initial_evaluation',
      errorText: 'CPP initial evaluation',
    },
    {
      fieldName: 'child_follow_up_session',
      errorText: 'CPP follow up',
    },
    {
      fieldName: 'smp_session',
      errorText: 'Stress Management Program',
    },
    {
      fieldName: 'minor_medication_management_initial_evaluation',
      errorText: 'Minor management initial evaluation',
    },
    {
      fieldName: 'minor_medication_management_follow_up_evaluation',
      errorText: 'Minor management follow up',
    },
    {
      fieldName: 'minor_medication_management_follow_up_low_complexity',
      errorText: 'Minor medication management follow up (low complexity)',
    },
    {
      fieldName: 'minor_medication_management_follow_up_moderate_complexity',
      errorText: 'Minor medication management follow up (moderate complexity)',
    },
    {
      fieldName: 'minor_medication_management_follow_up_high_complexity',
      errorText: 'Minor medication management follow up (high complexity)',
    },
    {
      fieldName: 'differential_pricing_in_person_modifier',
      errorText: 'In person modifier',
    },
    {
      fieldName: 'dbt_session',
      errorText: 'DBT session',
    },
    {
      fieldName: 'dbt_group_session',
      errorText: 'DBT group session',
    },
    {
      fieldName: 'dbt_teens_intake_session',
      errorText: 'DBT Teens intake session',
    },
    {
      fieldName: 'dbt_teens_followup_session',
      errorText: 'DBT Teens follow-up session',
    },
    {
      fieldName: 'dbt_teens_caregiver_session',
      errorText: 'DBT Teens caregiver session',
    },
    {
      fieldName: 'dbt_teens_family_session',
      errorText: 'DBT Teens family session',
    },
    {
      fieldName: 'dbt_teens_group_session',
      errorText: 'DBT Teens group session',
    },
    {
      fieldName: 'dbt_teens_medication_initial_session',
      errorText: 'DBT Teens medication initial session',
    },
    {
      fieldName: 'dbt_teens_medication_followup_session',
      errorText: 'DBT Teens medication follow-up session',
    },
    {
      fieldName: 'caregiver_training_for_neuro_session',
      errorText: 'Caregiver training session',
    },
    {
      fieldName: 'neurodiversity_skills_coaching_session',
      errorText: 'Neurodiversity skills coaching session',
    },
    {
      fieldName: 'manager_coaching_session',
      errorText: 'Manager growth coaching session',
    },
  ]
  for (const r of areNumbers) {
    let value = $$values.get(r.fieldName)
    if (value) {
      value = isString(value) ? value : value.toString()
      if (!isValidCurrencyAmount(value)) {
        errors[r.fieldName] = r.errorText + ' rate must be a number'
      }
    }
  }

  return errors
}

export default providerRatesValidate
